import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface InsuranceRatesTableProps {
}

export const InsuranceRatesTable: React.FC<InsuranceRatesTableProps> = () => {

    const insuranceRatesState = useAppSelector(state => state.insuranceRates);

    return (
        <>
            <table className="data">
                <thead>
                <tr>
                    <th>Hinnapiir</th>
                    <th>Hind</th>
                    <th>Omavastutus</th>
                    <th>Poliisitasu</th>
                    <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {insuranceRatesState.insuranceRates.map(row => {
                    return (
                        <tr key={row.id}>
                            <td>
                                {row.price_limit}
                            </td>
                            <td>
                                {row.price}
                            </td>
                            <td>
                                {row.own_responsibility}
                            </td>
                            <td>
                                {row.policy_price}
                            </td>
                            <td className="action">
                                <Link to={`/insurance/${row.id}/modify`}>Muuda</Link>
                                <span>|</span>
                                <Link to={`/insurance/${row.id}/delete`}>Kustuta</Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <ul className="table-actions">
                <li>
                    <Link to="/insurance/new">
                        <strong>Lisa uus kindlustuse hind</strong>
                    </Link>
                </li>
            </ul>
        </>
    );

}